import { merge } from 'lodash';

import { AdditionalFiltersDict } from '../typings/domain';

import { LocalStorage, StorageKeyType } from './Storage/Storage';

export class AdditionalFiltersInStorageHelpers {
    public static getFilter(defaults: AdditionalFiltersDict): AdditionalFiltersDict {
        const additionalFilters = LocalStorage.getItem(StorageKeyType.additionalFilter);

        if (!additionalFilters) {
            return defaults;
        }

        return merge(defaults, additionalFilters);
    }

    public static setFilter(additionalFilter: AdditionalFiltersDict): void {
        LocalStorage.setItem(StorageKeyType.additionalFilter, additionalFilter);
    }
}
